import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotels-manage',
  templateUrl: './hotels-manage.component.html',
  styleUrls: ['./hotels-manage.component.scss']
})
export class HotelsManageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
